import axios from "axios";

const api = axios.create({
  // baseURL: 'http://localhost:3002'
  baseURL: 'https://api.igrys.com/fluxodecaixa-back'
  // baseURL: 'http://192.168.0.110:3002'
})
export default api